import { Box, Typography } from "@mui/material";

import type { DocumentsPageItem } from "../Documents.utils";

type DocumentsTableDragOverlayProps = {
  items: DocumentsPageItem[];
  totalCount: number;
};

const MAX_VISIBLE_PREVIEW_ITEMS = 3;

const renderDragOverlayItem = (item: DocumentsPageItem) => {
  const Icon = item.icon;

  return (
    <Box
      data-testid="documents-table-drag-overlay-item"
      sx={{
        alignItems: "center",
        bgcolor: "#FFFFFF",
        border: "1px solid #D7E3F8",
        borderRadius: "6px",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.16)",
        color: "#111827",
        display: "flex",
        gap: "10px",
        minHeight: 42,
        minWidth: 0,
        opacity: 0.82,
        overflow: "hidden",
        px: 1.5,
        py: 1,
        width: 300,
      }}
    >
      <Icon
        aria-hidden="true"
        fontSize="small"
        sx={{
          color: "#4B5563",
          flex: "none",
        }}
      />
      <Typography
        noWrap
        sx={{
          fontSize: "14px",
          minWidth: 0,
        }}
        variant="body2"
      >
        {item.name || "No name"}
      </Typography>
    </Box>
  );
};

export const DocumentsTableDragOverlay = ({
  items,
  totalCount,
}: DocumentsTableDragOverlayProps) => {
  const visibleItems = items.slice(0, MAX_VISIBLE_PREVIEW_ITEMS);

  if (visibleItems.length === 0) {
    return null;
  }

  return (
    <Box
      data-testid="documents-table-drag-overlay"
      sx={{
        maxWidth: "calc(100vw - 32px)",
        pointerEvents: "none",
        position: "relative",
        width: 300,
      }}
    >
      <Box
        data-testid="documents-table-drag-overlay-stack"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        {visibleItems.map((item) => (
          <Box key={`${item.kind}:${item.id}`}>
            {renderDragOverlayItem(item)}
          </Box>
        ))}
      </Box>

      {totalCount > 1 ? (
        <Box
          data-testid="documents-table-drag-overlay-count-badge"
          sx={{
            alignItems: "center",
            bgcolor: "#DC2626",
            borderRadius: 999,
            boxShadow: "0 4px 12px rgba(15, 23, 42, 0.18)",
            color: "#FFFFFF",
            display: "flex",
            fontSize: "12px",
            fontWeight: 700,
            height: 28,
            justifyContent: "center",
            left: "50%",
            minWidth: 28,
            px: 1,
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: visibleItems.length + 1,
          }}
        >
          {totalCount}
        </Box>
      ) : null}
    </Box>
  );
};
